
import "./Download_app.css";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Download_app() {
    return (
        <section className="Download-App">
            <Container>
                <Row className="mainrow">
                    <Col lg={5} md={6} className="first-col">
                        <div className="heading-holder">
                            <h2>Download the App</h2>
                            <div className="border-line my-3"></div>
                        </div>
                        <div className="text-holder">
                            <h6>Ready to turn your passion into profit?</h6>
                            <p className="content-text">
                                Our network-based money-earning app is the ultimate tool to help you grow your connections, boost your sales, and earn money, all from the convenience of your smartphone.
                            </p>
                        </div>
                        <div className="button-holder mt-5">
                            <Link
                            //  to={"https://play.google.com/store/apps/details?id=com.profcyma.absar_solutions"}
                            to={"https://mywealthwave.in/mywealth.apk"}
                            target="_blank"
                            >

                                <img
                                    className="app-image me-3"
                                    src={
                                        process.env.PUBLIC_URL + "/Assets/Images/icon/downloadapp.jpg"
                                    }
                                    alt="app-image"
                                /></Link>
                            {/* <img
                                className="app-image2"
                                src={
                                    process.env.PUBLIC_URL + "/Assets/Images/home/download_app/app-btn.png"
                                }
                                alt="app-image"
                            /> */}
                        </div>
                    </Col>
                    <Col lg={5} md={6} className="mx-auto second-col">
                        <div className="mobileimgdiv">
                            <img
                                className="mobileimg"
                                // src={
                                //     process.env.PUBLIC_URL + "/Assets/Images/home/download_app/download_app_img.png"
                                // }
                                src={
                                    process.env.PUBLIC_URL + "/Assets/Images/home/experience/1.png"
                                }

                                alt="mobileimg"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}
